import(/* webpackMode: "eager" */ "/app/src/app/impressum/page.tsx");
